import React, { useEffect, useMemo, useState } from "react";
import Condition from "./components/condition";
import Category from "./components/category";
import { DataBoardContext, DataBoardDefault, defaultValue } from "./index.context";
import { QueryParams } from "../../../services/data/dashboard";
import modStyl from './index.module.scss'
import { RouteChildrenProps } from "react-router-dom";
import { readProjectCode, readProjectId, writeProjectCode, writeProjectId } from "../../../utils/storage";

interface DataBoardComponentProps {
  mainTabIndex: string
  projectId: number
  projectCode: string
  tableScrollY?: number
  wrapperStyl?: React.CSSProperties
}

export const DataBoardComponent: React.FC<DataBoardComponentProps> = ({
    mainTabIndex,
    wrapperStyl = {
      height: 'calc(100vh - 55px)'
    },
    tableScrollY = window.innerHeight - 425,
    ...props
  })=> {

  const [tabIndex, setTabIndex] = useState<string>(defaultValue.tabIndex)

  const [queryParams, setQueryParams] = useState<QueryParams>({})
  
  const onSearch = (q: QueryParams)=> {
    setQueryParams({
      ...q
    })
  }

  const onChange = (index: string)=> {
    setTabIndex(index)
  }

  const {projectId, projectCode} = useMemo(()=> {
    return {
      projectId: readProjectId(props.projectId),
      projectCode: readProjectCode(props.projectCode)
    }
  }, [props])

  useEffect(()=> {
    if (props.projectId) {
      writeProjectId(props.projectId)
      writeProjectCode(props.projectCode)
    }

    setTabIndex('0')
  }, [])

  return (
    <div className={modStyl.wrapper} style={wrapperStyl}>
      <DataBoardContext.Provider value={{ tableScrollY, mainTabIndex, tabIndex, projectId, projectCode, queryParams }}>
        <Condition activeKey={tabIndex} onSearch={onSearch} />
        <Category onChange={onChange}/>
      </DataBoardContext.Provider>
    </div>
  )
}

type State = {
  id: number
  code: string
  activeKey: string
}

const DataBoard: React.FC<RouteChildrenProps<any, State>> = ({ location })=> {

  const { state } = location

  return (
    <DataBoardComponent mainTabIndex="0" projectId={state.id} projectCode={state.code}/>
  )
}
export default DataBoard